<div class="container mt-5">
  <div class="card card-primary">

    <!-- /.card-header -->
    <!-- form start -->
    <div class="row">
      <form id="quickForm" [formGroup]="eventForm" (ngSubmit)="onSubmit()">
        <div class="card-body">
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <app-form-field label="{{ 'First Name' }}" [required]="true" [control]="eventForm.controls['firstName']"
                  [isInline]="false">
                  <app-input formControlName="firstName"></app-input>
                </app-form-field>
              </div>
            </div>

            <div class="col-4">
              <div class="form-group">
                <app-form-field label="{{ 'Last Name' }}" [required]="true" [control]="eventForm.controls['lastName']"
                  [isInline]="false">
                  <app-input formControlName="lastName"></app-input>
                </app-form-field>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <app-form-field label="{{ 'Full Name' }}" [required]="true" [control]="eventForm.controls['fullName']"
                  [isInline]="false">
                  <app-input formControlName="fullName"></app-input>
                </app-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <app-form-field label="{{ 'Email' }}" [required]="true" [control]="eventForm.controls['email']"
                  [isInline]="false">
                  <app-input formControlName="email"></app-input>
                </app-form-field>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <app-form-field label="{{ 'Mobile Number' }}" [required]="true"
                  [control]="eventForm.controls['phoneNo']" [isInline]="false">
                  <app-input formControlName="phoneNo"></app-input>
                </app-form-field>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <app-form-field label="{{ 'Address' }}" [required]="true" [control]="eventForm.controls['address']"
                  [isInline]="false">
                  <app-input formControlName="address"></app-input>
                </app-form-field>
              </div>
            </div>
          </div>

          <div class="row">


            <div class="col-4">
              <div class="form-group">
                <app-form-field label="{{ 'Country' }}" [required]="true" [control]="eventForm.controls['countryId']"
                  [isInline]="false">
                  <datalist id="suggestions">
                    <option *ngFor="let item of countryList" value="{{item.value}}">{{item.label}}</option>
                  </datalist>
                  <input formControlName="countryId" class="form-control form-control-lg" control="eventForm.controls['countryId']" autoComplete="on" list="suggestions" />
                  
                  <!-- <app-datalist [items]="countryList" formControlName="countryId"></app-datalist> -->
                </app-form-field>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <app-form-field label="{{ 'City' }}" [required]="true" [control]="eventForm.controls['city']"
                  [isInline]="false">
                  <app-input formControlName="city"></app-input>
                </app-form-field>
              </div>
            </div>

            <div class="col-4">
              <div class="form-group">
                <app-form-field label="{{ 'Zip Code'}}" [required]="true" [control]="eventForm.controls['zipCode']"
                  [isInline]="false">
                  <app-input formControlName="zipCode"></app-input>
                </app-form-field>
              </div>
            </div>
          </div>
        </div>
        <!-- /.card-body -->
        <div class="card-footer">
          <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button> &nbsp;&nbsp;
          <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss({ refresh: false })">
            Close
          </button>
        </div>
      </form>
    </div>
  </div>


</div>
<script src="../../plugins/jquery/jquery.min.js"></script>
<script src="../../plugins/bootstrap/js/bootstrap.bundle.min.js"></script>
<!-- Select2 -->
<script src="../../../../assets/plugins/select2/js/select2.full.min.js"></script>

<script>
  $(document).ready(function () {
    $("#myInput").on("keyup", function () {
      var value = $(this).val().toLowerCase();
      $(".dropdown-menu li").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
      });
    });
  });
</script>